import { CHARACTERS, type CharacterId } from "@spieleparadies/shared";

import { CharacterAvatar } from "./CharacterAvatar";

interface CharacterPickerProps {
  selected: CharacterId;
  onSelect: (id: CharacterId) => void;
  disabled?: boolean;
}

export function CharacterPicker({ selected, onSelect, disabled }: CharacterPickerProps) {
  return (
    <div className="character-grid">
      {CHARACTERS.map((char) => {
        const isActive = char.id === selected;
        return (
          <button
            key={char.id}
            type="button"
            className={`character-tile ${isActive ? "active" : ""}`}
            onClick={() => onSelect(char.id)}
            disabled={disabled}
            aria-pressed={isActive}
          >
            <CharacterAvatar character={char} size={72} />
            <div className="character-meta">
              <span className="character-name">{char.name}</span>
              <span className="character-desc">{char.description}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
